import React from 'react';
import NavigationStore from "../../stores/NavigationStore";
import SongStore from "../../stores/SongStore";
import NavigationChangeTabAction from "../../actions/NavigationChangeTabAction";
import InstrumentItem from './InstrumentItem';
import EffectItem from './EffectItem';
import MidiItem from './MidiItem';
import PropTypes from 'prop-types';
export default class Navigator extends React.Component {
	static propTypes = {
		name: PropTypes.string
	};

	static contextTypes = {
		executeAction: PropTypes.func.isRequired,
		getStore: PropTypes.func.isRequired
	};

	constructor(props, context) {
		super(props, context);
		const store = context.getStore(NavigationStore);
        const songStore = context.getStore(SongStore);
		this.state = {
			selected: store.getSelected(),
			tabs: store.getTabInfo(),
			bindings: songStore.getMidiBindings(),
			removeMode: false
		};
		store.on('NAVIGATION_SELECTED_TAB_CHANGE', () => {
			this.setState({
				selected: store.getSelected()
			});
		});

		this.bindings = songStore.getMidiBindings();

		songStore.on('MIDI_BINDINGS_CHANGE', (bindings) => {
			this.setState({
				bindings: songStore.getMidiBindings()
			});
		});

	}
	handleTabClick(name) {
		this.context.executeAction(NavigationChangeTabAction, { name: name });
	}

	handleEnableRemoveMode(event) {
		event.preventDefault();
		this.setState({
			removeMode: !this.state.removeMode
		});
	}

	render() {

        const displayType = this.state.selected.className, i = 0;

        const tabs = this.state.tabs.map((tab) => {
			return (<li key={tab.name} className={(tab.className == displayType ? "active " : "") + tab.className }
						onClick={this.handleTabClick.bind(this, tab.className)}>{tab.name}</li>)
		});

        let items = [];

		if(displayType === "midi") {
			this.state.bindings.forEach((bindings, key) => {
				items.push(...bindings.map((binding) => {
					return (<MidiItem key={key + i} {...binding} midi_path={key}/>);
				}));
			});
		} else {
			items = this.state.selected.items.map((item, i) => {
				if(displayType == "instruments") {
					return (<InstrumentItem name={item.name} type={item.type} key={i}/>);
				} else if(displayType == "effects") {
					return (<EffectItem name={item.name} type={item.type} key={i}/>);
				}
			});
		}

		return (
		  <div className="Navigator">
			<ul className="tabs">
				{tabs}
			</ul>
			<ul className="list">
				{items}
			</ul>
		  </div>
		);
	}
}
